import { render } from "./page_context_menu.vue?vue&type=template&id=bc2c28ac"
import script from "./page_context_menu.vue?vue&type=script&lang=js"
export * from "./page_context_menu.vue?vue&type=script&lang=js"

import exportComponent from "/home/premiergalop/dev/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__